import { useEffect, useState, MouseEvent } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import { postPromotion } from '../../api/coupons'
import { postMypayAcc } from '../../api/login'
import { getOrderDetail, getReviewableProduct, putUserConfirm } from '../../api/orderHistory'
import { AFWebLinkType, handlePostMessage, RNPostMessage } from '../../js/postMessage'
import { plusComma } from '../../js/script'
import MyChannerlTalk from './MyChannerTalk'
import { getMyReview } from '../../api/product'
import { useCommonContext } from '../provider/CommonProvider'
import { useAppContext } from '../provider/AppProvider'

export function OrderCancelComplete({ el }: any) {
  const navigate = useNavigate()
  const { isAppView } = useAppContext()

  const onClickOrderDetail = () => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderdetail/${el.orderNo}`,
      })
    } else {
      navigate(`/orderdetail/${el.orderNo}`)
    }
  }

  const onClickProduct = (e: MouseEvent<HTMLAnchorElement>, el: any) => {
    e.preventDefault()
    console.log('onClickProduct')
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productNo}`,
      })
    } else {
      navigate(`/product/${el.productNo}`)
    }
  }

  return (
    <div className='order_box'>
      <div className='order_dateline'>
        <i></i>
        <p className='order_date'>{el.orderYmdt?.split(' ', 1).join().replaceAll('-', '. ').replaceAll('. 0', '. ')}</p>
      </div>
      <div className='order_tit'>
        <div className='f_box'>
          <strong>
            <p>주문번호</p>
            <div onClick={onClickOrderDetail}>{el.orderNo}</div>
          </strong>
          <span className='g_color'>주문취소완료</span>
        </div>
        <button type='button' onClick={onClickOrderDetail}>
          주문내역 상세
        </button>
      </div>
      <div className='order_item'>
        {el.orderOptions?.map((element: any) => {
          return (
            <div className='g_color order_item_info' key={element.orderOptionNo}>
              <div className='info_wrap'>
                <div className='img_box'>
                  <div className='dim'></div>
                  <Link to={`/product/${element?.productNo}`} onClick={(e) => onClickProduct(e, element)}>
                    <img src={element?.imageUrl} alt='productImage' />
                  </Link>
                </div>
                <div className='item_txt'>
                  <p className='brand_name'>
                    <Link to={`/product/${element?.productNo}`} onClick={(e) => onClickProduct(e, element)}>
                      {element?.brandName}
                    </Link>
                  </p>
                  <p className='product_name'>
                    <Link to={`/product/${element?.productNo}`} onClick={(e) => onClickProduct(e, element)}>
                      {element?.productName}
                    </Link>
                  </p>
                  <p className='product_option'>옵션 : {element.optionValue}</p>
                  <p className='product_amount'>수량 : {element.orderCnt}개</p>
                  <p className='product_sale_price'>
                    {plusComma(element?.price?.salePrice + element?.price?.addPrice)}원
                  </p>
                  <div className='discounted_price'>
                    <p className='percent'>
                      {Math.floor(
                        (element.price?.immediateDiscountAmt / (element?.price?.salePrice + element?.price?.addPrice)) *
                          100
                      )}
                      %
                    </p>
                    <p className='price'>
                      {plusComma(
                        element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                      )}
                      원
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

//주문 완료 or 배송 준비중
export function OrderComplete({ el, type }: any) {
  const navigate = useNavigate()
  const { isAppView } = useAppContext()

  const [claimArray, setClaimArray] = useState<any>([])

  const onClickOrderDetail = () => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderdetail/${el.orderNo}`,
      })
    } else {
      navigate(`/orderdetail/${el.orderNo}`)
    }
  }

  useEffect(() => {
    getOrderDetail(el.orderNo)
      .then((res) => {})
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []
      el?.orderOptions.map((el: any) => {
        if (el.claimStatusType === 'CANCEL_REQUEST' || el.claimStatusType === 'RETURN_REJECT_REQUEST') {
          claimArray.push(el.orderOptionNo)
          text.push(el.claimStatusType)
        } else if (el.claimStatusType === null) {
          array.push(el.orderOptionNo)
        }
        // setOptionArray(array);
        setClaimArray(text)
        // setClaimText(text);
      })
    }
  }, [el])

  return (
    <div className='order_box'>
      <div className='order_dateline'>
        <i></i>
        <p className='order_date'>{el.orderYmdt?.split(' ', 1).join().replaceAll('-', '. ').replaceAll('. 0', '. ')}</p>
      </div>

      <div className={'order_tit'}>
        <div className='f_box'>
          <strong>
            <p>주문번호</p>
            <div onClick={onClickOrderDetail}>{el.orderNo}</div>
          </strong>
          <span
            style={{
              background:
                (type.includes('PAY_DONE') && claimArray.length === 0) ||
                (type.includes('PRODUCT_PREPARE') && claimArray.length === 0) ||
                (type.includes('DELIVERY_PREPARE') && claimArray.length === 0)
                  ? 'var(--colLightBlue)'
                  : 'var(--colGray2)',
              color:
                (type.includes('PAY_DONE') && claimArray.length === 0) ||
                (type.includes('PRODUCT_PREPARE') && claimArray.length === 0) ||
                (type.includes('DELIVERY_PREPARE') && claimArray.length === 0) ||
                claimArray.length === 0
                  ? 'var(--colPointBlue)'
                  : 'var(--colGray7)',
            }}
          >
            {((type.includes('PAY_DONE') && claimArray.length === 0) ||
              (type.includes('PRODUCT_PREPARE') && claimArray.length === 0)) &&
              '주문완료'}

            {type.includes('DELIVERY_PREPARE') && claimArray.length === 0 && '배송준비중'}
            {claimArray.length === 0 ? null : '취소신청'}
          </span>
        </div>
        <button type='button' onClick={onClickOrderDetail}>
          주문내역 상세
        </button>
      </div>

      <div className='order_item'>
        {el.orderOptions?.map((element: any) => {
          return (
            <div
              className={
                element?.claimStatusType === 'CANCEL_REQUEST' || element.claimStatusType === 'CANCEL_DONE'
                  ? 'order_item_info g_color'
                  : 'order_item_info'
              }
              key={element.orderOptionNo}
            >
              <div className='info_wrap'>
                <div
                  onClick={() => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${element?.productNo}`,
                      })
                    } else {
                      navigate(`/product/${element?.productNo}`)
                    }
                  }}
                >
                  <div className='img_box'>
                    <div className='dim'></div>
                    <img src={element?.imageUrl} alt='productImage' />
                  </div>
                </div>
                <div
                  onClick={() => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${element?.productNo}`,
                      })
                    } else {
                      navigate(`/product/${element?.productNo}`)
                    }
                  }}
                >
                  <div className='item_txt'>
                    <p className='brand_name'>{element?.brandName}</p>
                    <p className='product_name'>{element?.productName}</p>
                    <p className='product_option'>옵션 : {element.optionValue}</p>
                    <p className='product_amount'>수량 : {element.orderCnt}개</p>

                    {Math.floor(
                      (element.price?.immediateDiscountAmt / (element?.price?.salePrice + element?.price?.addPrice)) *
                        100
                    ) === 0 ? (
                      <>
                        <div className='discounted_price'>
                          <p className='price'>
                            {plusComma(
                              element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                            )}
                            원
                          </p>
                        </div>
                      </>
                    ) : (
                      <>
                        <p className='product_sale_price'>
                          {plusComma(element?.price?.salePrice + element?.price?.addPrice)}원
                        </p>
                        <div className='discounted_price'>
                          <p className='percent'>
                            {Math.floor(
                              (element.price?.immediateDiscountAmt /
                                (element?.price?.salePrice + element?.price?.addPrice)) *
                                100
                            )}
                            %
                          </p>
                          <p className='price'>
                            {plusComma(
                              element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                            )}
                            원
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      {type.includes('DELIVERY_PREPARE') ? (
        <div className='order_btn'>
          <button
            type='button'
            onClick={() => {
              const CT = new MyChannerlTalk()
              CT.boot({ pluginKey: '168ab92f-c06e-476b-a2cb-95c54ee01572' })
              CT.openChat()
              return () => {
                CT.shutdown()
              }
            }}
          >
            1:1 문의하기
          </button>
        </div>
      ) : (type.includes('PAY_DONE') && claimArray.length === 0) ||
        (type.includes('PRODUCT_PREPARE') && claimArray.length === 0) ? (
        <div className='order_btn'>
          <button
            type='button'
            onClick={() => {
              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/ordercancel?orderNo=${el.orderNo}`,
                })
              } else {
                navigate(`/ordercancel?orderNo=${el.orderNo}`)
              }
            }}
          >
            주문취소
          </button>
        </div>
      ) : null}
    </div>
  )
}

//배송중
export function DeliveryIng({ el }: any) {
  const navigate = useNavigate()
  const { isAppView } = useAppContext()

  const [claimArray, setClaimArray] = useState<any>([])
  const [claimText, setClaimText] = useState<any>([])
  const [url, setUrl] = useState('')
  const [lastNumber, setLastNumber] = useState()

  const onClickOrderDetail = () => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderdetail/${el.orderNo}`,
      })
    } else {
      navigate(`/orderdetail/${el.orderNo}`)
    }
  }

  useEffect(() => {
    el.orderOptions.map((element: any) => {
      setUrl(element.delivery.retrieveInvoiceUrl)
    })
  }, [el])
  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []
      el?.orderOptions?.map((el: any) => {
        if (
          el.claimStatusType === 'RETURN_REQUEST' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_DONE' ||
          el.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          el.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          claimArray.push(el.orderOptionNo)
          text.push(el.claimStatusType)
        } else if (el.claimStatusType === null) {
          array.push(el.orderOptionNo)
        }
        setClaimArray(claimArray)
        setClaimText(text)
      })
    }
  }, [el])
  useEffect(() => {
    if (el) {
      const array: any = []
      el?.orderOptions?.map((element: any) => {
        if (
          element.claimStatusType === 'RETURN_REQUEST' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          element.claimStatusType === 'RETURN_DONE' ||
          element.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          element.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          array.push(element)
        }
        setLastNumber(array.length)
      })
    }
  }, [el])

  return (
    <div className='order_box' key={el.orderOptions[0]?.orderOptionNo}>
      <div className='order_dateline'>
        <i></i>
        <p className='order_date'>{el.orderYmdt?.split(' ', 1).join().replaceAll('-', '. ').replaceAll('. 0', '. ')}</p>
      </div>

      <div className='order_tit'>
        <div className='f_box'>
          <strong>
            <p>주문번호</p>
            <div onClick={onClickOrderDetail}>{el.orderNo}</div>
          </strong>
          <span
            style={{
              background: claimArray.length === el.orderOptions.length ? 'var(--colGray2)' : 'var(--colLightBlue)',
              color: claimArray.length === el.orderOptions.length ? 'var(--colGray7)' : 'var(--colPointBlue)',
            }}
          >
            {claimArray.length === el.orderOptions.length
              ? claimText.includes('RETURN_REQUEST') || claimText.includes('RETURN_PROC_BEFORE_RECEIVE')
                ? '환불신청'
                : '환불완료'
              : '배송중'}
          </span>
        </div>
        <button type='button' onClick={onClickOrderDetail}>
          주문내역 상세
        </button>
      </div>

      <div className='order_item'>
        {el.orderOptions?.map((element: any) => {
          if (element.claimStatusType !== 'RETURN_NO_REFUND') {
            return (
              <div className='order_item_info' key={element.orderOptionNo}>
                <div className='info_wrap'>
                  <div className='img_box'>
                    <div className='dim'></div>
                    <img src={element?.imageUrl} alt='productImage' />
                  </div>
                  <div className='item_txt'>
                    <p className='brand_name'>{element?.brandName}</p>
                    <p className='product_name'>{element?.productName}</p>
                    <p className='product_option'>옵션 : {element.optionValue}</p>
                    <p className='product_amount'>수량 : {element.orderCnt}개</p>
                    <p className='product_sale_price'>
                      {plusComma(element?.price?.salePrice + element?.price?.addPrice)}원
                    </p>
                    <div className='discounted_price'>
                      <p className='percent'>
                        {Math.floor(
                          (element.price?.immediateDiscountAmt /
                            (element?.price?.salePrice + element?.price?.addPrice)) *
                            100
                        )}
                        %
                      </p>
                      <p className='price'>
                        {plusComma(
                          element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                        )}
                        원
                      </p>
                    </div>
                    {element.claimStatusType === 'RETURN_REQUEST' ||
                    element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
                    element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
                    element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
                    element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
                    element.claimStatusType === 'RETURN_DONE' ? null : (
                      <div className='small_buttons'>
                        <div className='wrap'>
                          <div
                            onClick={() => {
                              if (isAppView) {
                                RNPostMessage(AFWebLinkType.moveToLink, {
                                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${url}`,
                                })
                              } else {
                                navigate(url)
                              }
                            }}
                          >
                            배송조회
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {element.claimStatusType === 'RETURN_REQUEST' ||
                element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
                element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
                element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
                element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
                element.claimStatusType === 'RETURN_DONE' ? (
                  <div
                    style={{
                      padding: '16px 12px',
                      borderRadius: '5px',
                      background: 'var(--colGray2)',
                    }}
                  >
                    <p
                      style={{
                        fontSize: '12px',
                        lineHeight: '18px',
                        color: 'var(--colGray5)',
                        textAlign: 'center',
                      }}
                    >
                      <b
                        style={{
                          color: 'var(--colGray6)',
                          display: 'block',
                          marginBottom: '4px',
                        }}
                      >
                        환불 신청이 완료되었습니다
                      </b>
                      반품 절차는 택배사 일정에 따라
                      <br /> 영업일 기준 5~10일까지 소요될 수 있습니다.
                    </p>
                  </div>
                ) : null}
              </div>
            )
          } else {
            return (
              <div className='g_color order_item_info' key={element.orderOptionNo}>
                <div className='info_wrap'>
                  <div className='img_box'>
                    <div className='dim'></div>
                    <img src={element?.imageUrl} alt='productImage' />
                  </div>
                  <div className='item_txt'>
                    <p className='brand_name'>{element?.brandName}</p>
                    <p className='product_name'>{element?.productName}</p>
                    <p className='product_option'>옵션 : {element.optionValue}</p>
                    <p className='product_amount'>수량 : {element.orderCnt}개</p>
                    <p className='product_sale_price'>
                      {plusComma(element?.price?.salePrice + element?.price?.addPrice)}원
                    </p>
                    <div className='discounted_price'>
                      <p className='percent'>
                        {Math.floor(
                          (element.price?.immediateDiscountAmt /
                            (element?.price?.salePrice + element?.price?.addPrice)) *
                            100
                        )}
                        %
                      </p>
                      <p className='price'>
                        {plusComma(
                          element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                        )}
                        원
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        })}
      </div>
      {claimArray.length !== 0 && claimArray.length === lastNumber ? null : (
        <>
          <div className='order_btn'>
            <button
              type='button'
              onClick={() => {
                if (isAppView) {
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderrefund?orderNo=${el.orderNo}`,
                  })
                } else {
                  navigate(`/orderrefund?orderNo=${el.orderNo}`)
                }
              }}
            >
              환불신청
            </button>
          </div>
          <div className='order_btn'>
            <button
              type='button'
              onClick={() => {
                const CT = new MyChannerlTalk()
                CT.boot({ pluginKey: '168ab92f-c06e-476b-a2cb-95c54ee01572' })
                CT.openChat()
                return () => {
                  CT.shutdown()
                }
              }}
            >
              1:1 문의하기
            </button>
          </div>
        </>
      )}
    </div>
  )
}

// 배송 완료
export function DeliveryCompleted({ el, setSubmit, userData, mypayCount, mypayCoupon }: any) {
  const navigate = useNavigate()
  const { isAppView } = useAppContext()

  const [reviewable, setReviewable] = useState<any>([])
  const [claimArray, setClaimArray] = useState<any>([])
  const [claimText, setClaimText] = useState<any>([])
  const [url, setUrl] = useState('')
  const [coupon, setCoupon] = useState(false)

  const onClickOrderDetail = () => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderdetail/${el.orderNo}`,
      })
    } else {
      navigate(`/orderdetail/${el.orderNo}`)
    }
  }

  useEffect(() => {
    el.orderOptions.map((element: any) => {
      setUrl(element.delivery.retrieveInvoiceUrl)
    })
  }, [el])

  useEffect(() => {
    if (el) {
      el.orderOptions.map((element: any) => {
        getReviewableProduct(element.productNo).then((res) => {
          setReviewable((prev: any) => [...prev, res.data.reviewable])
        })
      })
    }
  }, [el])
  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []
      el?.orderOptions.map((el: any) => {
        if (
          el.claimStatusType === 'RETURN_REQUEST' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_DONE' ||
          el.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          el.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          claimArray.push(el.orderOptionNo)
          text.push(el.claimStatusType)
        } else if (el.claimStatusType === null) {
          array.push(el.orderOptionNo)
        }

        setClaimArray(claimArray)
        setClaimText(text)
      })
    }
  }, [el])

  return (
    <div className='order_box'>
      <div className='order_dateline'>
        <i></i>
        <p className='order_date'>{el.orderYmdt?.split(' ', 1).join().replaceAll('-', '. ').replaceAll('. 0', '. ')}</p>
      </div>

      <div className='order_tit'>
        <div className='f_box'>
          <strong>
            <p>주문번호</p>
            <div onClick={onClickOrderDetail}>{el.orderNo}</div>
          </strong>
          <span
            style={{
              background: claimArray.length === el.orderOptions.length ? 'var(--colGray2)' : 'var(--colLightBlue)',
              color: claimArray.length === el.orderOptions.length ? 'var(--colGray7)' : 'var(--colPointBlue)',
            }}
          >
            {claimArray.length === el.orderOptions.length
              ? claimText.includes('RETURN_REQUEST') || claimText.includes('RETURN_PROC_BEFORE_RECEIVE')
                ? '환불신청'
                : '환불완료'
              : '배송완료'}
          </span>
        </div>
        <button type='button' onClick={onClickOrderDetail}>
          주문내역 상세
        </button>
      </div>

      <div className='order_item'>
        {el.orderOptions?.map((element: any, idx: number) => {
          if (element.claimStatusType !== 'RETURN_NO_REFUND') {
            return (
              <div className='order_item_info' key={element.orderOptionNo}>
                <div className='info_wrap'>
                  <div className='img_box'>
                    <div className='dim'></div>
                    <img src={element?.imageUrl} alt='productImage' />
                  </div>
                  <div className='item_txt'>
                    <p className='brand_name'>{element?.brandName}</p>
                    <p className='product_name'>{element?.productName}</p>
                    <p className='product_option'>옵션 : {element.optionValue}</p>
                    <p className='product_amount'>수량 : {element.orderCnt}개</p>
                    <p className='product_sale_price'>
                      {plusComma(element?.price?.salePrice + element?.price?.addPrice)}원
                    </p>
                    <div className='discounted_price'>
                      <p className='percent'>
                        {Math.floor(
                          (element.price?.immediateDiscountAmt /
                            (element?.price?.salePrice + element?.price?.addPrice)) *
                            100
                        )}
                        %
                      </p>
                      <p className='price'>
                        {plusComma(
                          element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                        )}
                        원
                      </p>
                    </div>
                    {element.claimStatusType === 'RETURN_REQUEST' ||
                    element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
                    element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
                    element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
                    element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
                    element.claimStatusType === 'RETURN_DONE' ? null : element.orderStatusType === 'BUY_CONFIRM' ? (
                      <div className='small_buttons'>
                        <div className='wrap'>
                          {reviewable[idx] ? (
                            <button
                              type='button'
                              className='black'
                              onClick={() => {
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.moveToLink, {
                                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${
                                      process.env.REACT_APP_SHOP_URL
                                    }/reviewwrite/${el.productNo}?reviewNo=null&productNo=${
                                      element.productNo
                                    }&orderNo=${element.orderNo}&optionValue=${element.optionValue || null}`,
                                  })
                                } else {
                                  navigate(`/reviewwrite/${element.productNo}`, {
                                    state: {
                                      reviewNo: null,
                                      productNo: element.productNo,
                                      orderNo: element.orderNo,
                                      optionValue: element.optionValue || null,
                                    },
                                  })
                                }
                              }}
                            >
                              리뷰작성
                            </button>
                          ) : null}
                        </div>
                      </div>
                    ) : (
                      <div className='small_buttons'>
                        <div className='wrap'>
                          <button
                            type='button'
                            onClick={() => {
                              const confirmed = window.confirm('상품 구매확정을 하시겠습니까?')
                              if (confirmed) {
                                if (el.pgType === 'MY_PAY') {
                                  putUserConfirm(element.orderOptionNo)
                                    .then((res) => {
                                      setSubmit((prev: boolean) => !prev)
                                      alert('구매확정이 완료되었습니다.')
                                      const couponDown = false
                                      const price =
                                        (Number(element.price.salePrice) - Number(element.price.immediateDiscountAmt)) *
                                        0.02

                                      postPromotion('uu6weWziAWYWvcGvy2yY')
                                        .then((res: any) => {
                                          setCoupon(true)
                                          // Move alert here after coupon success
                                          postMypayAcc(userData.memberNo, element.orderOptionNo, price).then((res) => {
                                            if (res.data.code === 'E0805') {
                                              alert('이미 지급 되었습니다.')
                                            } else if (res.data.code === 'E9803' || res.data.code === 'E0603') {
                                              // Handle other codes
                                            } else {
                                              alert(
                                                '어바웃피싱 페이 이용 혜택으로 쿠폰과 추가 페이백이 지급되었습니다. 마이쇼핑에서 확인해 보세요.'
                                              )
                                            }
                                          })
                                        })
                                        .catch((err) => {
                                          setCoupon(false)
                                          console.log(err)
                                          postMypayAcc(userData.memberNo, element.orderOptionNo, price).then((res) => {
                                            if (res.data.code === 'E0805') {
                                              alert('이미 지급 되었습니다.')
                                            } else if (res.data.code === 'E9803' || res.data.code === 'E0603') {
                                              // Handle other codes
                                            } else {
                                              alert(
                                                '어바웃피싱 페이 이용혜택으로 추가 페이백이 지급되었습니다. 마이쇼핑에서 확인해 보세요.'
                                              )
                                            }
                                          })
                                        })
                                    })
                                    .catch((err) => {
                                      console.log(err)
                                    })
                                } else {
                                  putUserConfirm(element.orderOptionNo)
                                    .then((res) => {
                                      setSubmit((prev: boolean) => !prev)
                                      alert('구매확정이 완료되었습니다.')
                                    })
                                    .catch((err) => {
                                      console.log(err)
                                    })
                                }
                              }
                            }}
                          >
                            구매확정
                          </button>
                          <button
                            onClick={() => {
                              if (isAppView) {
                                handlePostMessage({ actionType: 'moveToLinkNaver', params: { url: url } })
                              } else {
                                window.location.href = url
                              }
                            }}
                          >
                            배송조회
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {element.claimStatusType === null ? null : element.claimStatusType === 'RETURN_REQUEST' ||
                  element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
                  element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
                  element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
                  element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ? (
                  <div
                    style={
                      isMobile
                        ? {
                            padding: '16px 12px',
                            borderRadius: '5px',
                            background: 'var(--colGray1)',
                          }
                        : {
                            padding: '20px',
                            borderRadius: '5px',
                            background: 'var(--colGray1)',
                          }
                    }
                  >
                    <p
                      style={
                        isMobile
                          ? {
                              fontSize: '12px',
                              lineHeight: '18px',
                              color: 'var(--colGray5)',
                              textAlign: 'center',
                            }
                          : {
                              fontSize: '14px',
                              fontWeight: '500',
                              lineHeight: '20px',
                              color: 'var(--colGray5)',
                              textAlign: 'center',
                            }
                      }
                    >
                      <b
                        style={
                          isMobile
                            ? {
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginBottom: '4px',
                              }
                            : {
                                fontSize: '16px',
                                fontWeight: '600',
                                lineHeight: '24px',
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginBottom: '4px',
                              }
                        }
                      >
                        환불 신청이 완료되었습니다
                      </b>
                      반품 절차는 택배사 일정에 따라
                      <br /> 영업일 기준 5~10일까지 소요될 수 있습니다.
                    </p>
                  </div>
                ) : (
                  <div
                    style={
                      isMobile
                        ? {
                            padding: '16px 12px',
                            borderRadius: '5px',
                            background: 'var(--colGray1)',
                          }
                        : {
                            padding: '20px',
                            borderRadius: '5px',
                            background: 'var(--colGray1)',
                          }
                    }
                  >
                    <p
                      style={
                        isMobile
                          ? {
                              fontSize: '12px',
                              lineHeight: '18px',
                              color: 'var(--colGray5)',
                              textAlign: 'center',
                            }
                          : {
                              fontSize: '14px',
                              fontWeight: '500',
                              lineHeight: '20px',
                              color: 'var(--colGray5)',
                              textAlign: 'center',
                            }
                      }
                    >
                      <b
                        style={
                          isMobile
                            ? {
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginBottom: '4px',
                              }
                            : {
                                fontSize: '16px',
                                fontWeight: '600',
                                lineHeight: '24px',
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginBottom: '4px',
                              }
                        }
                      >
                        환불이 완료되었습니다.
                      </b>
                      카드사 결제 취소 처리는
                      <br /> 영업일 기준 3~5일까지 소요될 수 있습니다.
                    </p>
                  </div>
                )}
              </div>
            )
          } else {
            return (
              <div className='g_color order_item_info' key={element.orderOptionNo}>
                <div className='info_wrap'>
                  <div className='img_box'>
                    <img src={element?.imageUrl} alt='productImage' />
                  </div>
                  <div className='item_txt'>
                    <p className='brand_name'>{element?.brandName}</p>
                    <p className='product_name'>{element?.productName}</p>
                    <p className='product_option'>옵션 : {element.optionValue}</p>
                    <p className='product_amount'>수량 : {element.orderCnt}개</p>
                    <p className='product_sale_price'>
                      {plusComma(element?.price?.salePrice + element?.price?.addPrice)}원
                    </p>
                    <div className='discounted_price'>
                      <p className='percent'>
                        {Math.floor(
                          (element.price?.immediateDiscountAmt /
                            (element?.price?.salePrice + element?.price?.addPrice)) *
                            100
                        )}
                        %
                      </p>
                      <p className='price'>
                        {plusComma(
                          element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                        )}
                        원
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        })}
      </div>
      {claimArray.length === 0 ? (
        <>
          <div className='order_btn'>
            {/* <button type="button">구매확정</button> */}
            <button
              type='button'
              onClick={() => {
                if (isAppView) {
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderrefund?orderNo=${el.orderNo}`,
                  })
                } else {
                  navigate(`/orderrefund?orderNo=${el.orderNo}`)
                }
              }}
            >
              환불신청
            </button>
          </div>
          <div className='order_btn'>
            <button
              type='button'
              onClick={() => {
                const CT = new MyChannerlTalk()
                CT.boot({ pluginKey: '168ab92f-c06e-476b-a2cb-95c54ee01572' })
                CT.openChat()
                return () => {
                  CT.shutdown()
                }
              }}
            >
              1:1 문의하기
            </button>
          </div>
        </>
      ) : null}
    </div>
  )
}

export function PurChaseConfirmation({ el }: any) {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()
  const { hasAccessToken } = useCommonContext()

  const [reviewable, setReviewable] = useState<any>([])
  const [claimArray, setClaimArray] = useState<any>([])
  const [claimText, setClaimText] = useState<any>([])
  const [myReview, setMyReview] = useState<any>({})

  const onClickOrderDetail = () => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderdetail/${el.orderNo}`,
      })
    } else {
      navigate(`/orderdetail/${el.orderNo}`)
    }
  }

  useEffect(() => {
    if (hasAccessToken) {
      getMyReview().then((res) => {
        res.data.items.forEach((item: any) => {
          if (item.orderNo === el.orderNo) {
            console.log('item ==>', item)

            setMyReview(item)
          }
        })
      })
    }
  }, [])

  useEffect(() => {
    if (el) {
      const array: any = []
      const claimArray: any = []
      const text: any = []
      el?.orderOptions.map((el: any) => {
        if (
          el.claimStatusType === 'RETURN_REQUEST' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
          el.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
          el.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ||
          el.claimStatusType === 'RETURN_REJECT_REQUEST' ||
          el.claimStatusType === 'RETURN_DONE' ||
          el.claimStatusType === 'RETURN_REFUND_AMT_ADJUST_REQUESTED' ||
          el.claimStatusType === 'RETURN_NO_REFUND'
        ) {
          claimArray.push(el.orderOptionNo)
          text.push(el.claimStatusType)
        } else if (el.claimStatusType === null) {
          array.push(el.orderOptionNo)
        }
        setClaimArray(claimArray)
        setClaimText(text)
      })
    }
  }, [el])
  useEffect(() => {
    if (el) {
      el.orderOptions.map((element: any) => {
        getReviewableProduct(element.productNo).then((res) => {
          setReviewable((prev: any) => [...prev, res.data.reviewable])
        })
      })
    }
  }, [el])

  return (
    <div className='order_box'>
      <div className='order_dateline'>
        <i></i>
        <p className='order_date'>{el.orderYmdt?.split(' ', 1).join().replaceAll('-', '. ').replaceAll('. 0', '. ')}</p>
      </div>

      <div className='order_tit'>
        <div className='f_box'>
          <strong>
            <p>주문번호</p>
            <div onClick={onClickOrderDetail}>{el.orderNo}</div>
          </strong>
          <span className='g_color'>
            {claimArray.length === el.orderOptions.length
              ? claimText.includes('RETURN_REQUEST') || claimText.includes('RETURN_PROC_BEFORE_RECEIVE')
                ? '환불신청'
                : '환불완료'
              : '구매확정'}
          </span>
        </div>
        <button type='button' onClick={onClickOrderDetail}>
          주문내역 상세
        </button>
      </div>

      <div className='order_item'>
        {el.orderOptions?.map((element: any, idx: number) => {
          if (element.claimStatusType === null) {
            return (
              <div className='order_item_info' key={element.orderOptionNo}>
                <div className='info_wrap'>
                  <div className='img_box'>
                    <div className='dim'></div>
                    <img src={element?.imageUrl} alt='productImage' />
                  </div>
                  <div className='item_txt'>
                    <p className='brand_name'>{element?.brandName}</p>
                    <p className='product_name'>{element?.productName}</p>
                    <p className='product_option'>옵션 : {element.optionValue}</p>
                    <p className='product_amount'>수량 : {element.orderCnt}개</p>
                    <p className='product_sale_price'>
                      {plusComma(element?.price?.salePrice + element?.price?.addPrice)}원
                    </p>
                    <div className='discounted_price'>
                      <p className='percent'>
                        {Math.floor(
                          (element.price?.immediateDiscountAmt /
                            (element?.price?.salePrice + element?.price?.addPrice)) *
                            100
                        )}
                        %
                      </p>
                      <p className='price'>
                        {plusComma(
                          element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                        )}
                        원
                      </p>
                    </div>
                    <div className='small_buttons'>
                      <div className='wrap'>
                        {reviewable[idx] ? (
                          <button
                            type='button'
                            className='black'
                            onClick={() => {
                              if (myReview.orderNo) {
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.moveToLink, {
                                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/reviewwrite/${element.productNo}?reviewNo=${myReview.reviewNo}&productNo=${element.productNo}&orderNo=${element.orderNo}`,
                                  })
                                } else {
                                  navigate(`/reviewwrite/${element.productNo}`, {
                                    state: {
                                      reviewNo: myReview.reviewNo,
                                      productNo: element.productNo,
                                      orderNo: element.orderNo,
                                    },
                                  })
                                }
                              } else {
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.moveToLink, {
                                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${
                                      process.env.REACT_APP_SHOP_URL
                                    }/reviewwrite/${element.productNo}?reviewNo=null&productNo=${
                                      element.productNo
                                    }&orderNo=${element.orderNo}&optionValue=${element.optionValue || null}`,
                                  })
                                } else {
                                  navigate(`/reviewwrite/${element.productNo}`, {
                                    state: {
                                      reviewNo: null,
                                      productNo: element.productNo,
                                      orderNo: element.orderNo,
                                      optionValue: element.optionValue || null,
                                    },
                                  })
                                }
                              }
                            }}
                          >
                            리뷰작성
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          } else {
            return (
              <>
                <div className='g_color order_item_info'>
                  <div className='info_wrap'>
                    <div className='img_box'>
                      <div className='dim'></div>
                      <img src={element?.imageUrl} alt='productImage' />
                    </div>
                    <div className='item_txt'>
                      <p className='brand_name'>{element?.brandName}</p>
                      <p className='product_name'>{element?.productName}</p>
                      <p className='product_option'>옵션 : {element.optionValue}</p>
                      <p className='product_amount'>수량 : {element.orderCnt}개</p>
                      <p className='product_sale_price'>
                        {plusComma(element?.price?.salePrice + element?.price?.addPrice)}원
                      </p>
                      <div className='discounted_price'>
                        <p className='percent'>
                          {Math.floor(
                            (element.price?.immediateDiscountAmt /
                              (element?.price?.salePrice + element?.price?.addPrice)) *
                              100
                          )}
                          %
                        </p>
                        <p className='price'>
                          {plusComma(
                            element?.price?.salePrice + element?.price?.addPrice - element.price.immediateDiscountAmt
                          )}
                          원
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {element.claimStatusType === null ? null : element.claimStatusType === 'RETURN_REQUEST' ||
                  element.claimStatusType === 'RETURN_REJECT_REQUEST' ||
                  element.claimStatusType === 'RETURN_PROC_BEFORE_RECEIVE' ||
                  element.claimStatusType === 'RETURN_PROC_REQUEST_REFUND' ||
                  element.claimStatusType === 'RETURN_PROC_WAITING_REFUND' ? (
                  <div
                    style={
                      isMobile
                        ? {
                            padding: '16px 12px',
                            borderRadius: '5px',
                            background: 'var(--colGray1)',
                          }
                        : {
                            padding: '20px',
                            borderRadius: '5px',
                            background: 'var(--colGray1)',
                          }
                    }
                  >
                    <p
                      style={
                        isMobile
                          ? {
                              fontSize: '12px',
                              lineHeight: '18px',
                              color: 'var(--colGray5)',
                              textAlign: 'center',
                            }
                          : {
                              fontSize: '14px',
                              fontWeight: '500',
                              lineHeight: '20px',
                              color: 'var(--colGray5)',
                              textAlign: 'center',
                            }
                      }
                    >
                      <b
                        style={
                          isMobile
                            ? {
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginBottom: '4px',
                              }
                            : {
                                fontSize: '16px',
                                fontWeight: '600',
                                lineHeight: '24px',
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginBottom: '4px',
                              }
                        }
                      >
                        환불 신청이 완료되었습니다
                      </b>
                      반품 절차는 택배사 일정에 따라
                      <br /> 영업일 기준 5~10일까지 소요될 수 있습니다.
                    </p>
                  </div>
                ) : (
                  <div
                    style={
                      isMobile
                        ? {
                            padding: '16px 12px',
                            borderRadius: '5px',
                            background: 'var(--colGray1)',
                          }
                        : {
                            padding: '20px',
                            borderRadius: '5px',
                            background: 'var(--colGray1)',
                          }
                    }
                  >
                    <p
                      style={
                        isMobile
                          ? {
                              fontSize: '12px',
                              lineHeight: '18px',
                              color: 'var(--colGray5)',
                              textAlign: 'center',
                            }
                          : {
                              fontSize: '14px',
                              fontWeight: '500',
                              lineHeight: '20px',
                              color: 'var(--colGray5)',
                              textAlign: 'center',
                            }
                      }
                    >
                      <b
                        style={
                          isMobile
                            ? {
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginBottom: '4px',
                              }
                            : {
                                fontSize: '16px',
                                fontWeight: '600',
                                lineHeight: '24px',
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginBottom: '4px',
                              }
                        }
                      >
                        환불이 완료되었습니다.
                      </b>
                      카드사 결제 취소 처리는
                      <br /> 영업일 기준 3~5일까지 소요될 수 있습니다.
                    </p>
                  </div>
                )}
              </>
            )
          }
        })}
      </div>
    </div>
  )
}
